{
  "Device Orders": "Device Orders",
  "Locations": "Locations",
  "There are currently no locations accessible for viewing {{pageTitle}}.": "There are currently no locations accessible for viewing {{pageTitle}}.",
  "View and manage device orders made through Weave.": "View and manage device orders made through Weave.",
  "View and manage device orders made through Weave. Select your preferred location to continue:": "View and manage device orders made through Weave. Select your preferred location to continue:"
}
